const { VITE_ENV } = import.meta.env;
const isDevelop = VITE_ENV === 'develop';

const POLAR_PRODUCTS = {
  develop: {
    starter: {
      monthly: '30e7ba6d-64cd-43fb-9b98-cf7d3f6e11b4',
      yearly: '945db95c-d118-4a45-8d15-634088320007',
    },
    scaler: {
      monthly: 'da04191c-767f-484b-bc66-e6b230ab46f6',
      yearly: '8ea9535a-41ef-48e7-bd76-54e4c2cf48e3',
    },
  },
  production: {
    starter: {
      monthly: 'b64de2e8-a970-419f-a502-f3911abde44b',
      yearly: 'ee6ed854-3692-4b51-a6b7-af49332c0008',
    },
    scaler: {
      monthly: 'd10af13a-af83-4645-ad56-1798ece6316b',
      yearly: 'fae079c5-0455-46c7-b8ca-7919e933473d',
    },
  },
};

const PRODUCTS = POLAR_PRODUCTS[isDevelop ? 'develop' : 'production'];

export const PLANS = {
  launch: {
    title: 'Free',
    plan: 'free',
    monthlyPrice: 0,
    yearlyPrice: 0,
    monthlyProductId: '',
    yearlyProductId: '',
    description: 'Essential features you need to get started',
    features: ['1 Project', '10 Feature requests', 'Feature moderation'],
    actionLabel: 'Downgrade',
  },
  starter: {
    title: 'Launch',
    plan: 'starter',
    monthlyPrice: 15,
    yearlyPrice: 150,
    monthlyProductId: PRODUCTS.starter.monthly,
    yearlyProductId: PRODUCTS.starter.yearly,
    description: 'Unlock the full potential for your projects',
    features: [
      '3 Projects',
      'Feature requests',
      'Extended feature moderation',
      'Members',
      'Feature comments',
      'Notifications',
      'User segmentation',
      'No watermarks',
    ],
    actionLabel: 'Upgrade',
    popular: true,
    exclusive: true,
  },
  scaler: {
    title: 'Scale',
    plan: 'scaler',
    monthlyPrice: 30,
    yearlyPrice: 300,
    monthlyProductId: PRODUCTS.scaler.monthly,
    yearlyProductId: PRODUCTS.scaler.yearly,
    description: 'No limits for your business',
    features: [
      'Unlimited Projects',
      'Feature requests',
      'Extended feature moderation',
      'Members',
      'Feature comments',
      'Notifications',
      'User segmentation',
      'No watermarks',
      'Priority support',
    ],
    actionLabel: 'Upgrade',
  },
};
